/**
 * @generated SignedSource<<dac6579b1869c62e10c6b805c3799c3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroModule_componentModule$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroCarousel_componentModule">;
  readonly " $fragmentType": "HpSharedHeroModule_componentModule";
};
export type HpSharedHeroModule_componentModule$key = {
  readonly " $data"?: HpSharedHeroModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroModule_componentModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedHeroCarousel_componentModule"
    }
  ],
  "type": "HeroModule",
  "abstractKey": null
};

(node as any).hash = "df7cb68e373510f3ac6313c5218b86a5";

export default node;
